import React from 'react';
import { PSPBenefit } from '../../interfaces/medicine';
import { Tag, TagLabel } from '../UI-CHAKRA/Tag';
import { Avatar } from '@chakra-ui/react';

interface MedicineBenefitsChipProps {
  benefit: PSPBenefit;
}

export default function MedicineBenefitsChip(props: MedicineBenefitsChipProps) {
  const { benefit } = props;

  return (
    <Tag variant={'solid'} borderRadius={'full'} backgroundColor={benefit.CorFundo}>
      <Avatar src={benefit.Logo} height={'12px'} width={'auto'} bgColor={'inherit'} mr={'2px'} />
      <TagLabel fontWeight={500} color={benefit.CorTexto} fontSize={'12px'}>
        {benefit.Nome}
      </TagLabel>
    </Tag>
  );
}
